import { render } from "./PaginationComponent.vue?vue&type=template&id=765f19be&scoped=true"
import script from "./PaginationComponent.vue?vue&type=script&lang=js"
export * from "./PaginationComponent.vue?vue&type=script&lang=js"

import "./PaginationComponent.vue?vue&type=style&index=0&id=765f19be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765f19be"]])

export default __exports__